var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DisclaimerDisclosure disclosure"},[_vm._t("default"),_c('a',{class:_vm.linkClass,attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();return _vm.openModalDisclaimerDisclosure()}}},[_vm._t("linkName")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }